class e {
  constructor() {
  }
  validate(a, c) {
    switch (c) {
      case "gr":
      case "jp":
      case "hk":
      case "my":
      case "in":
      case "il":
        return !!a.match(/^([^0-9]+)$/);
      default:
        return !!a.match(/^[a-zA-Z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017E\u01CD-\u01FF-'\s]+$/);
    }
  }
}
export {
  e as default
};
